<div mat-dialog-title class="dialog-header">
    <div>
        <h4 class="modal-title">Project beschrijving</h4>
    </div>
    <button aria-label="Close" class="close-button" mat-dialog-close="" tabindex="-1">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
@if (form) {
    <div mat-dialog-content [formGroup]="form" class="modal-body">
        <simple-tiny
            [content]="form.get('description')"
            elementId="description"
            ngDefaultControl
            propertyName="value"></simple-tiny>
        @if (form.get('content')?.invalid) {
            <mat-error>Content is een verplicht veld</mat-error>
        }
    </div>
}
<div mat-dialog-actions class="modal-footer">
    <button mat-dialog-close color="primary" mat-button type="button">Sluiten</button>
    <div class="spacer"></div>
    <button (click)="save()" color="primary" mat-raised-button type="button">Opslaan</button>
</div>
